import React, { useState } from 'react';
// Dialogs
import ContentCategoryFormDialog from 'dialogs/ContentCategoryForm.dialog';

const ContentCategoriesCreate = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);

  return (
    <>
      <div className="text-right mb-3">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={handleShow}
        >Create content category</button>
      </div>
      {show ? (
        <ContentCategoryFormDialog
          show={show}
          onHide={handleHide}
        />
      ) : null}
    </>
  )
}

export default ContentCategoriesCreate;
